import { useMutation, useQueryClient } from '@tanstack/react-query'
import checkTicketPortalApi from 'api/checkTicketPortalApi'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import ToastHelper from 'general/helpers/ToastHelper'
import { isArray } from 'lodash'
import { useRef } from 'react'

export default function DeleteModal({ open, toggleModalState, selected }) {
  const modalRef = useRef(null)
  const queryClient = useQueryClient()
  const { mutate, isLoading } = useMutation({
    mutationKey: 'deleteCheckPoint',
    mutationFn: (data) => checkTicketPortalApi.delete(data),
    onError: (err) => ToastHelper.showError(err?.message ?? 'Có lỗi xảy ra'),
    onSuccess: () => {
      ToastHelper.showSuccess('Xoá cổng soát vé thành công')
      toggleModalState(false)
      queryClient.invalidateQueries({
        queryKey: ['getCheckTicketPortal'],
      })
    },
  })
  return (
    <DraggableModal
      title="Xác nhận xoá ?"
      description={`Bạn chắc chắn muốn xoá ${
        isArray(selected) ? 'các' : ''
      } cổng giao vé này`}
      cancelText="Huỷ bỏ"
      applyText="Xác nhận"
      ref={modalRef}
      isOpen={open}
      isLoading={isLoading}
      onOpenChange={(state) => toggleModalState(state)}
      handleApplyChanges={() =>
        mutate({
          pointCheckTicketIds: isArray(selected) ? selected : [selected],
        })
      }
    />
  )
}
